import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, Stack } from '@mui/material';
import apiService from '../services/apiService.ts';

interface Props {
  open: boolean;
  onClose: () => void;
  tenantId: string;
  initial?: any;
  onSaved: () => void;
}

const LocationDialog: React.FC<Props> = ({ open, onClose, tenantId, initial, onSaved }) => {
  const [name, setName] = useState('');
  const [address, setAddress] = useState('');

  useEffect(() => {
    if (initial) {
      setName(initial.name || '');
      setAddress(initial.address || '');
    } else {
      setName('');
      setAddress('');
    }
  }, [initial]);

  const handleSave = async () => {
    const payload = { name, address };
    if (initial?.id) {
      await apiService.updateLocation(tenantId, initial.id, payload);
    } else {
      await apiService.createLocation(tenantId, payload);
    }
    onSaved();
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{initial ? 'Edit Location' : 'New Location'}</DialogTitle>
      <DialogContent>
        <Stack spacing={2} mt={1}>
          <TextField label="Name" value={name} onChange={e=>setName(e.target.value)} fullWidth />
          <TextField label="Address" value={address} onChange={e=>setAddress(e.target.value)} fullWidth />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={handleSave}>Save</Button>
      </DialogActions>
    </Dialog>
  );
};

export default LocationDialog;